"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageOperator = void 0;
var ErrorMessageOperator;
(function (ErrorMessageOperator) {
    ErrorMessageOperator["REQUIRED"] = "required";
    ErrorMessageOperator["IN"] = "in";
    ErrorMessageOperator["NOT_IN"] = "not-in";
    ErrorMessageOperator["BETWEEN"] = "between";
    ErrorMessageOperator["MATCH"] = "match";
    /** 自定义 */
    ErrorMessageOperator["CUSTOM"] = "custom";
})(ErrorMessageOperator || (exports.ErrorMessageOperator = ErrorMessageOperator = {}));
